export const ACOMMERCE_STATUS_OPTIONS = [
  'NEW',
  'IN_PROGRESS',
  'BACK_ORDERED',
  'COMPLETED',
  'CANCELLED',
  'ERROR',
  'WAREHOUSE_SUBMITTED',
  'READY_TO_PICK',
  'QC_CHECKED',
  'PACKED',
  'READY_TO_SHIP',
  'IN_TRANSIT',
  'OUT_FOR_DELIVER',
  'REJECTED_BY_CUSTOMER',
  'FAILED_TO_DELIVER',
  'DELIVERED',
  'PREPARING_DELIVERY'
]

export const STATUS_OPTIONS = [
  {
    label: 'ordered',
    value: 'ordered'
  },
  {
    label: 'paid',
    value: 'paid'
  },
  {
    label: 'shipped',
    value: 'shipped'
  },
  {
    label: 'cancel',
    value: 'canceled'
  }
]



// WEBPACK FOOTER //
// ./src/constants/acommerce.js